import React, { useContext } from 'react'
import { GlobalDataContext } from "../../context/context";
import CountUp from 'react-countup';
import { FaChild, FaPencilRuler } from 'react-icons/fa';
import { IoIosPeople } from 'react-icons/io';
import { MdFamilyRestroom } from 'react-icons/md';



const CounterUp = ({ image }) => {

    const { rpdata } = useContext(GlobalDataContext);


    const counterInfo = [
        {
            icon: (
                <FaChild fontSize={100} className='text-white mx-auto p-6'/>

            ),
            title: rpdata?.dbPrincipal?.exprYears ? 'Years Of Experience' : 'Best Service',
            number: rpdata?.dbPrincipal?.exprYears ? rpdata?.dbPrincipal?.exprYears : '100',
            simbolo: rpdata?.dbPrincipal?.exprYears ? '+' : '%',
        },
        {
            icon: (
                <MdFamilyRestroom fontSize={100} className="text-white mx-auto p-6 "/>
            ),
            title: 'Professionals',
            number: 100,
            simbolo: '%',
        },
        {
            icon: (
                <FaPencilRuler fontSize={100} className="text-white mx-auto p-6 "/>
            ),
            title: rpdata?.dbPrincipal?.miles ? `Miles Around ${rpdata?.dbPrincipal?.location[0]?.address}` : 'Cost-Effectiveness',
            number: rpdata?.dbPrincipal?.miles ? rpdata?.dbPrincipal?.miles : '100',
            simbolo: rpdata?.dbPrincipal?.miles ? '+' : '%',
        },
        {
            icon: (
                <IoIosPeople fontSize={100} className="text-white mx-auto p-6 "/>
            ),
            title: 'On Time',
            number: 100,
            simbolo: '%',
        },
    ]

    return (
        <div className='bgCountent' style={{ backgroundImage: `url("${image ? image : rpdata?.stock?.[1]}")` }}>
            <h2 className='text-center py-4 relative text-white'>{rpdata?.dbSlogan?.[4].slogan}</h2>
            <div className='w-4/5 mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4'>
                {
                    counterInfo.map((items, index) => {
                        const colorContent = index % 2 === 0 ? "bg-2 m-2 rounded-xl hover:transform hover:rotate-1 hover:scale-105 transition-all duration-500" : "bg2 m-2 rounded-xl hover:transform hover:rotate-1 hover:scale-105 transition-all duration-500"
                        return (
                            <div key={index} className={`text-center p-3 relative flex flex-col justify-center items-center ${colorContent}`}>
                                <div>
                                    {items.icon}

                                    <CountUp
                                        end={items.number}
                                        duration={5}
                                        className='text-white text-[69px]'
                                    />
                                    <span className='text-white text-[69px]'>{items.simbolo}</span>
                                </div>
                                <p className='text-white text-[18px]'>{items.title}</p>
                            </div>
                        )
                    })
                }
                <div>

                </div>
            </div>
        </div>
    )
}
export default CounterUp
